import { render } from "./refundDetail.vue?vue&type=template&id=c824d842&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"

import "./refundDetail.vue?vue&type=style&index=0&id=c824d842&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c824d842"

export default script